import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconSidebarOn$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSidebarOn extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '382407b1fb88566cc8824cf573370e188fa18bbd', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'ebf8c172f5d773dec054d4ae0c1eabaf04e66766', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '9766988b8081c8e2bab50cfabd0a5f014caa035a', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.54 4.002 19.36 4c.223 0 .304.023.385.067a.45.45 0 0 1 .19.189c.043.081.066.162.066.385v12.718c0 .223-.023.304-.067.385a.45.45 0 0 1-.189.19c-.081.043-.162.066-.385.066H2.641c-.223 0-.304-.023-.385-.067a.45.45 0 0 1-.19-.189.6.6 0 0 1-.064-.285L2 4.641c0-.223.023-.304.067-.385a.45.45 0 0 1 .189-.19.6.6 0 0 1 .285-.064M18.5 5.5h-15v11h15zM17 7h-4v8h4z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-sidebar-on", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-sidebar-on"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-sidebar-on":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSidebarOn$1);
            }
            break;
    } });
}

const CosmosIconSidebarOn = CosmosIconSidebarOn$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSidebarOn, defineCustomElement };
